import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Link from 'redux-first-router-link';
import Price from './Price';
import Button from '../Elements/Button/Button';
import Checkbox from '../Elements/Checkbox/Checkbox';
import Input from '../Elements/Input/Input';
import FakeSelect from '../Elements/FakeSelect/FakeSelect';
import cartAnalytics from '../Selection/cartAnalytics';
import { addEvent, removeEvent, addClass, removeClass, purifier } from '../../utils/dom';
import { prefix, translate, translateObjectData } from '../../utils/locale';
import { urlify, fieldValidation } from '../../utils/string';
import { addToBag, changeAddressInput, booleanChange, productAlert } from '../../actions/checkout';
import s from './Purchase.scss';

class Purchase extends Component {
	constructor(props) {
		super(props);

		const { sizes } = props;

		this.state = {
			formError: false,
			formErrorHover: false,
			emailError: false,
			addedToBag: false,
			showNotifyMe: false,
			showNotifyThanks: false,
			selected: sizes.length === 1 ? sizes[0].item : false,
			selectedLength: null,
			selectedTurnUps: null,
		};

		this.formElement = React.createRef();
	}

	componentDidMount() {
		addEvent(document.querySelector('body'), 'click.clearFormError', (e) => {
			if (this.formElement.current && !this.formElement.current.contains(e.target) && this.state.formError) {
				e.stopPropagation();
				e.preventDefault();
				this.setState({
					formError: false,
					showNotifyMe: false,
				});
			}
		});

		addEvent(window, 'keydown.clearFormError', (e) => {
			if (e.key === 'Escape') {
				this.setState({
					formError: false,
					showNotifyMe: false,
				});
			}
		});
	}

	componentWillUnmount() {
		removeEvent(document.querySelector('body'), 'click.clearFormError');
		removeEvent(window, 'keydown.clearFormError');
		removeClass(document.body, 'u_addedToBag');
	}

	onNotifyMe = (sizes) => {
		const { selected } = this.state;

		if (selected) {
			let hasErrors = false;
			const $input = this.formElement.current.querySelector('#notifyMeEmail');
			const value = $input.value;
			const returnErrors = this.onAddressInputBlur('email', value);
			if (returnErrors) hasErrors = true;

			if (hasErrors) return;

			this.props.productAlert({ selected }).then(() => {
				this.setState({ showNotifyThanks: true });

				window.setTimeout(() => {
					this.setState({
						selected: sizes.length === 1 ? sizes[0].item : false,
						addedToBag: false,
						showNotifyMe: false,
						showNotifyThanks: false,
					});
				}, 3000);

				return 1;
			}).catch(() => { console.log('DEBUG: failed to set up notification'); });
		}
	}

	addToBagHandler = (e) => {
		e.preventDefault();
		const { setup, productCache, productId, currentPath, originalProduct, checkout } = this.props;
		const { selectedLength, selectedTurnUps } = this.state;
		const currentCategory = currentPath.slice(0, currentPath.lastIndexOf('/'));
		let { selected } = this.state;
		let note = false;
		let sizeName = '';

		// All sizes must be added for purchase to be successful.
		if (selected) {
			const cachedProduct = productCache[setup.market][setup.pricelist].products[productId];

			if (originalProduct.lengths && originalProduct.turnups) {
				// Trousers check that length and turnups are chosen.
				if (selectedLength === null || selectedTurnUps === null) {
					this.setState({
						formError: true,
					});
					return;
				}
				cachedProduct.sizes.forEach((size) => {
					if (size.item === selected) sizeName = size.name;
				});
				note = {
					item: selected,
					details: {
						length: selectedLength,
						turnUps: selectedTurnUps,
					},
					message: `Product: ${cachedProduct.name} ${cachedProduct.variantName} — Size: ${sizeName} — Length: ${selectedLength} — Turn Ups: ${selectedTurnUps}`,
				};
			}

			if (cachedProduct.sizes.length === 1) selected = cachedProduct.sizes[0].item;

			if (this.state.showNotifyMe) {
				this.onNotifyMe(cachedProduct.sizes);
			} else if (cachedProduct.sizes.filter((item) => item.item === selected)?.[0]?.stock === 0) {
				this.setState({
					showNotifyMe: true,
				});
			} else {
				this.props.addToBag(selected, 1, currentPath, cachedProduct, note).then((response) => {
					addClass(document.body, 'u_addedToBag');

					const selectedSize = response.data.selection.items.filter((size) => size.item === selected).map((size) => ({ sizeSku: size.sku }))[0];
					cartAnalytics(cachedProduct, selectedSize, setup, originalProduct, currentCategory, response.data.selection, checkout.listItemCache, false, 1);

					setTimeout(() => {
						removeClass(document.body, 'u_addedToBag');
						this.setState({
							selected: cachedProduct.sizes.length === 1 ? cachedProduct.sizes[0].item : false,
							addedToBag: false,
						});
					}, 3000);
					return response;
				}).catch(() => { console.log('DEBUG: add to bag failed'); });

				this.setState({
					addedToBag: true,
				});
			}

			return;
		}

		this.setState({
			formError: true,
		});
	}

	selectSizeHandler = (item) => {
		this.setState({
			formError: false,
			selected: item,
		});
	}

	selectLengthHandler = (length) => {
		this.setState({
			formError: false,
			selectedLength: length,
		});
	}

	selectTurnUpHandler = (length) => {
		this.setState({
			formError: false,
			selectedTurnUps: length,
		});
	}

	toggleNotifyMeHandler = () => {
		this.setState((prevState) => ({
			showNotifyMe: !prevState.showNotifyMe,
			showNotifyThanks: false,
		}));
	}

	onAddressInputChange = (id, value) => {
		this.props.changeAddressInput('address', 'email', value);
		this.setState({ emailError: false });
	}

	onAddressInputBlur = (id, value) => {
		this.onAddressInputChange('email', value);

		if (fieldValidation(value, 'email')) {
			this.setState({ emailError: translate(this.props.setup, `error${fieldValidation(value, 'email')}`) });
			return true;
		}

		return false;
	}

	onBooleanChange = (id) => {
		this.props.booleanChange(id);
	};


	addToBagMouseEnterHandler = () => {
		const { selected } = this.state;

		if (!selected) {
			this.setState({
				formErrorHover: true,
			});
		}
	}

	addToBagMouseLeaveHandler = () => {
		this.setState({
			formErrorHover: false,
		});
	}

	render() {
		const { setup, sizes, checkout, soldOut, price, originalProduct } = this.props;
		const { formError, formErrorHover, emailError, addedToBag, selected, selectedLength, selectedTurnUps, showNotifyMe, showNotifyThanks } = this.state;
		const product = translateObjectData(setup, originalProduct);
		const formattedSizes = sizes.map((item) => ({
			key: item.item,
			value: item.name,
			disabled: item.stock === 0,
			selected: selected === item.item,
		}));

		const formattedLengths = (product.lengths && Object.keys(product.lengths).map((l) => ({
			key: urlify(product.lengths[l]),
			value: product.lengths[l],
			selected: selectedLength === urlify(product.lengths[l]),
		}))) || false;

		const formattedTurnUps = (product.turnups && Object.keys(product.turnups).map((l) => ({
			key: urlify(product.turnups[l]),
			value: product.turnups[l],
			selected: selectedTurnUps === urlify(product.turnups[l]),
		}))) || false;

		const selectedSize = selected && sizes.filter((item) => item.item === selected);

		let buttonText = formError || formErrorHover ? translate(setup, 'chooseSize') : translate(setup, 'addToBag');
		if (soldOut) buttonText = soldOut;
		if (addedToBag) buttonText = translate(setup, 'addedToBag');
		if (selectedSize?.[0]?.stock === 0) buttonText = translate(setup, 'sizeNotifyMeContinue');

		return (
			<form className={s.purchase} onSubmit={this.addToBagHandler} ref={this.formElement}>
				<span className={s.purchase_price}><Price price={price} soldOut={soldOut} product /></span>
				{ selectedSize.length > 0 && selectedSize[0].stock < 4 && selectedSize[0].stock > 0 && <span className={s.purchase_limitedLeft}>{ translate(setup, 'leftInStock').replace('%number%', selectedSize[0].stock) }</span> }
				{
					!showNotifyMe && sizes.length > 1 && (
						<div className={s.purchase_choice}>
							<FakeSelect open={formError && soldOut === false && !selected} items={formattedSizes} title={translate(setup, 'chooseSize')} selectionHandler={this.selectSizeHandler} />
						</div>
					)
				}
				{
					!showNotifyMe && formattedLengths && (
						<div className={[s.purchase_choice, s.purchase_choice__leg].join(' ')}>
							<div className={s.purchase_choice_length}>
								<FakeSelect open={formError && soldOut === false && selected && selectedLength === null} disabled={soldOut !== false} items={formattedLengths} title={translate(setup, 'chooseLength')} selectionHandler={this.selectLengthHandler} adaption="length" />
							</div>
							<div className={s.purchase_choice_length}>
								<FakeSelect open={formError && soldOut === false && selected && selectedTurnUps === null} disabled={soldOut !== false} items={formattedTurnUps} title={translate(setup, 'labelTurnUps')} selectionHandler={this.selectTurnUpHandler} adaption="turnups" />
							</div>
						</div>
					)
				}
				{
					showNotifyMe && selected ? (
						<div className={s.purchase_notifyMe}>
							<button className={s.purchase_notifyMe_close} type="button" aria-label="Close notify me" onClick={this.toggleNotifyMeHandler}>
								<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M0 0.706483L0.707 0L13.435 12.7187L12.728 13.4252L0 0.706483Z" fill="black" />
									<path d="M0.707 13.4252L0 12.7187L12.728 0L13.435 0.706483L0.707 13.4252Z" fill="black" />
								</svg>
							</button>
							<p className={s.purchase_notifyMe_intro} dangerouslySetInnerHTML={{ __html: purifier(translate(setup, (showNotifyThanks ? 'notifyMeDescriptionThanks' : 'notifyMeDescription')).replace('%size%', (sizes.length > 1 ? selectedSize[0].name : '')).replace('%product%', product.name)) }} />
							{
								!showNotifyThanks && (
									<>
										<Input id="notifyMeEmail" type="email" isError={emailError} value={checkout.payment.address.email} inputChange={this.onAddressInputChange} label={translate(setup, 'labelNotifyMe')} inputBlur={this.onAddressInputBlur} />
										<Checkbox id="subscribeToNewsletter" variantClasses={['checkbox__notifyMeTerms']} selected={checkout.payment.address.newsletter} inputChange={this.onBooleanChange}>
											<span dangerouslySetInnerHTML={{ __html: purifier(translate(setup, 'notifyMeNewsletterTerms')) }} />
										</Checkbox>
									</>
								)
							}
							<Button variantClasses={['button__fullWidth']} type="submit">{ showNotifyThanks ? translate(setup, 'notifyMeSubmitThanks') : translate(setup, 'notifyMeSubmit') }</Button>
						</div>
					) : (
						<div className={[s.purchase_submit, (soldOut ? s.purchase_submit__soldOut : null)].join(' ')}>
							<Button text={buttonText} mouseEnterEventHandler={this.addToBagMouseEnterHandler} mouseLeaveEventHandler={this.addToBagMouseLeaveHandler} />
						</div>
					)
				}
				{ checkout.addToBagError ? <div className={s.purchase_error}>{ translate(setup, 'addToBagError') }</div> : null }
				<Link className={s.purchase_giftCard} to={prefix(setup, `gift-card/${price.priceAsNumber}`)}>{ translate(setup, 'getAsGiftCard') }</Link>
			</form>
		);
	}
}

const mapState = ({ checkout, productCache }, { setup, currentPath, sizes, productId }) => ({
	sizes,
	productId,
	currentPath,
	setup,
	checkout,
	productCache,
});

export default hot(module)(connect(mapState, { addToBag, changeAddressInput, booleanChange, productAlert })(Purchase));
